<empty-layout *ngIf="layout === 'empty-layout'"></empty-layout>
<home-layout *ngIf="layout === 'home-layout'"></home-layout>
<common-layout *ngIf="layout === 'common-layout'"></common-layout>